import { Button } from 'components/Button/Button';
import { ButtonSize, ButtonVariant } from 'components/Button/Button.types';
import { ShowModalContainer } from 'containers/ShowModalContainer';

type Props = {
  className?: string;
  disabled?: boolean;
  listing: {
    id: string;
  };
  listingType: string;
  noIcon?: boolean;
  onClick?: () => void;
  title?: string;
  size?: ButtonSize;
  messageOverride?: string;
  variant?: ButtonVariant;
};

export function ShareListingButton({
  className,
  listing,
  listingType,
  onClick,
  title,
  messageOverride,
  disabled,
  noIcon,
  size,
  variant,
}: Props) {
  return (
    <ShowModalContainer
      render={(showModal) => (
        <Button
          className={className}
          icon={noIcon ? undefined : { type: 'normalized', name: 'share' }}
          aria-label="Share"
          data-qa-id="share-button"
          variant={variant || 'secondary'}
          disabled={disabled}
          size={size}
          onClick={(e) => {
            e.preventDefault();

            if (onClick) {
              onClick();
            }

            showModal('SHARE_LISTING', {
              // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'ListingTy... Remove this comment to see the full error message
              listingType,
              // @ts-expect-error TS(2741): Property 'type' is missing in type '{ id: string; ... Remove this comment to see the full error message
              listing,
              title,
              messageOverride,
            });
          }}
        >
          {getText('Share')}
        </Button>
      )}
    />
  );
}
